import React, { useState, useRef } from 'react';
import { useDebounce } from '@/store';

function TouchContainer({ className, onToushLeft, onToushRight, onToushTop, onToushBottom, children, style, onScrollBottom }) {

    const [toushStartX, setToushStartX] = useState()
    const [toushStartY, setToushStartY] = useState()
    const [scrollY, setScrollY] = useState(0)

    const container = useRef();

    const onTouchStartHandler = e => {
        setToushStartX(e.nativeEvent.pageX);
        setToushStartY(e.nativeEvent.pageY);
    }

    const onTouchEndHandler = e => {
        const toushEndX = e.nativeEvent.pageX;
        const toushEndY = e.nativeEvent.pageY;

        const x = toushEndX - toushStartX;
        const y = toushEndY - toushStartY;

        if (Math.abs(x) > Math.abs(y)) {
            if (x > 50 && onToushRight) onToushRight()
            if (x < -50 && onToushLeft) onToushLeft()
            return
        } else {
            if (y > 50 && onToushTop) onToushTop()
            if (y < -50 && onToushBottom) onToushBottom()
            return
        }
    }

    const _onScrollBottom = useDebounce((scrollHeight, scrollTop, clientHeight) => {
        const bottom = scrollHeight - (scrollTop + clientHeight);
        if (scrollTop > scrollY) {
            if (bottom < 100) onScrollBottom();
        }
        setScrollY(scrollTop);
    }, 200)

    const onScroll = e => {
        const target = container.current;
        _onScrollBottom(target.scrollHeight, target.scrollTop, target.clientHeight);
    }

    return (
        <div className={className} style={style} ref={container} onScroll={onScrollBottom ? onScroll : undefined} onTouchStart={onTouchStartHandler} onTouchEnd={onTouchEndHandler}>
            {children}
        </div>
    )
}

export default TouchContainer;